module.exports = __webpack_public_path__ + "img/flechaIzquierda.0419eaa4.svg";